import React from 'react';
import PropTypes from 'prop-types';

import styles from './NotFound.module.scss';

const NotFound = ({ message }) => {
  return (
    <div className={styles.container}>
      <p className={styles.oops}>Oops!</p>
      <p className={styles.error}>404 - Not found</p>
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

NotFound.propTypes = {
  message: PropTypes.string,
};

export default NotFound;
